export const SELECT_ALL_OPTION = {
    value: 'all',
    label: 'All',
};
//# sourceMappingURL=forms.js.map